import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widgets-user',
  templateUrl: './widgets-user.component.html',
})
export class WidgetsUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
